'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var hashlru = require('hashlru');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var hashlru__default = /*#__PURE__*/_interopDefaultLegacy(hashlru);

class TLRU {
  constructor(maxSize) {
    this.lru = hashlru__default["default"](maxSize);
  }
  get(key) {
    const value = this.lru.get(key);
    if (value) {
      if (value.expire && value.expire < Date.now()) {
        this.lru.remove(key);
        return undefined;
      }
      return value.value;
    }
    return undefined;
  }
  set(key, value, ttl) {
    this.lru.set(key, {
      value,
      expire: Date.now() + ttl
    });
  }
  has(key) {
    const value = this.get(key);
    if (value) {
      return true;
    }
    return false;
  }
  remove(key) {
    this.lru.remove(key);
  }
  clear() {
    this.lru.clear();
  }
}

exports.TLRU = TLRU;
